import { Menu, X } from "lucide-react";
import { useSidebar } from "./SidebarProvider";
import { useMediaQuery } from "../../hooks/useMediaQuery";

export function HamburgerButton() {
  const { expanded, mobileOpen, toggle, openMobile, triggerRef } = useSidebar();
  const isMd = useMediaQuery("(min-width: 768px)");

  const isOpen = isMd ? expanded : mobileOpen;
  const Icon = isOpen ? X : Menu;
  const label = isOpen ? "Close menu" : "Open menu";

  function handleClick() {
    if (isMd) {
      toggle();
    } else {
      openMobile();
    }
  }

  return (
    <button
      ref={triggerRef}
      type="button"
      onClick={handleClick}
      aria-label={label}
      aria-expanded={isOpen}
      className="flex h-10 w-10 items-center justify-center rounded-md text-ink-3 transition hover:bg-paper-2 hover:text-ink lg:hidden"
    >
      <Icon size={20} />
    </button>
  );
}
